// import React, { useState, useContext, useEffect } from "react";
// import { useNavigate, useParams, useLocation } from "react-router-dom";
// import CustomButton from "../Buttons/CustomButton";
// import ImageModal from "../Modals/ImageModal";
// import APICall from "../../Utility/APICall";
// import { paths } from "../../Utility/Constants";
// import { useAuth } from "../../Utility/AuthProvider";
// import { TenantContext } from "./TenantContext";
// import { useTenantContext } from "./TenantContext";
// import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
// import { storage } from "../../Utility/firebase";
// import {
//   FaPlus,
//   FaEye,
//   FaEdit,
//   FaTrash,
//   FaUpload,
//   FaCamera,
//   FaTimes,
//   FaPhone,
// } from "react-icons/fa";
// import { GetMediaURL } from "../../Utility/APICall";

// const AddNewTenant = () => {
//   const { jwt, user } = useAuth();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { unitId } = useParams();
//   const { addToCurrentAgreement } = useTenantContext();

//   // Get agreement data from navigation state
//   const agreementBody = location.state?.agreementBody || null;
//   const unit = location.state?.unit || null;
//   const isFromAddMoreTenant = location.state?.fromAddMoreTenant || false;
//   const existingTenantList = location.state?.tenantList || [];
//   const isUpdate = location.state?.isUpdate || false;
//   const originalAgreement = location.state?.originalAgreement || null;

//   // State for form fields
//   const [mobileNumber, setMobileNumber] = useState("");
//   const [tenantName, setTenantName] = useState("");
//   const [firstName, setFirstName] = useState("");
//   const [lastName, setLastName] = useState("");

//   // Add these new state variables for modification flow
//   const modifiedAgreementData = location.state?.modifiedAgreementData || null;
//   const isModifying = location.state?.isModifying || false;
//   const fromReviewTenants = location.state?.fromReviewTenants || false;

//   // State for file uploads - storing file objects for upload
//   const [profilePicture, setProfilePicture] = useState(null);
//   // const [profilePicturePreview, setProfilePicturePreview] = useState(null);
//   const [aadharFront, setAadharFront] = useState(null);
//   const [aadharBack, setAadharBack] = useState(null);
//   const [panCard, setPanCard] = useState(null);
//   const [rentAgreement, setRentAgreement] = useState(null);

//   // State for file previews
//   const [profilePreview, setProfilePreview] = useState(null);
//   const [aadharFrontPreview, setAadharFrontPreview] = useState(null);
//   const [aadharBackPreview, setAadharBackPreview] = useState(null);
//   const [panPreview, setPanPreview] = useState(null);
//   const [rentPreview, setRentPreview] = useState(null);

//   // // State for file uploads - storing both file and preview URL
//   // const [profilePicture, setProfilePicture] = useState({
//   //   file: null,
//   //   preview: null,
//   //   url: null,
//   // });
//   // const [aadharFront, setAadharFront] = useState({
//   //   file: null,
//   //   preview: null,
//   //   url: null,
//   // });
//   // const [aadharBack, setAadharBack] = useState({
//   //   file: null,
//   //   preview: null,
//   //   url: null,
//   // });
//   // const [panCard, setPanCard] = useState({
//   //   file: null,
//   //   preview: null,
//   //   url: null,
//   // });
//   // const [rentAgreement, setRentAgreement] = useState({
//   //   file: null,
//   //   preview: null,
//   //   url: null,
//   // });

//   // Upload states
//   const [uploadingFiles, setUploadingFiles] = useState({});
//   // const [uploadProgress, setUploadProgress] = useState({});

//   // State for tenant fetching
//   const [isTenantFetching, setIsTenantFetching] = useState(false);
//   const [tenantDetails, setTenantDetails] = useState({});
//   const [tenantFound, setTenantFound] = useState(false);
//   const [tenantNotFound, setTenantNotFound] = useState(false);

//   // State for modals
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [isImageModalOpen, setImageModalOpen] = useState(false);

//   // Form validation
//   const [isContinueActive, setIsContinueActive] = useState(false);
//   const isTenantDetailsEmpty = Object.keys(tenantDetails).length === 0;

//   const [isDocumentModalOpen, setDocumentModalOpen] = useState(false);
//   const [currentDocumentType, setCurrentDocumentType] = useState("");
//   const [currentDocumentSide, setCurrentDocumentSide] = useState("");

//   // Check if mobile number is 10 digits and fetch tenant
//   useEffect(() => {
//     if (mobileNumber.length === 10) {
//       fetchTenantDetails();
//     } else {
//       setTenantDetails({});
//       setTenantFound(false);
//       setTenantNotFound(false);
//     }
//   }, [mobileNumber]);

//   // Validate form
//   useEffect(() => {
//     const isValid =
//       mobileNumber.length === 10 &&
//       (!isTenantDetailsEmpty || tenantName.length > 2);
//     setIsContinueActive(isValid);
//   }, [mobileNumber, tenantDetails, tenantName, isTenantDetailsEmpty]);

//   const fetchTenantDetails = async () => {
//     try {
//       setIsTenantFetching(true);
//       setTenantFound(false);
//       setTenantNotFound(false);

//       const response = await APICall(
//         "POST",
//         paths.tenant.validate,
//         { mobile: mobileNumber },
//         undefined,
//         jwt
//       );

//       if (response.status === "success" && response.response.is_tenant) {
//         const tenantData = {
//           ...response.response,
//           tenant_in_db: true,
//         };
//         setTenantDetails(tenantData);
//         setTenantFound(true);

//         // Auto-fill name if tenant found
//         const fullName =
//           `${tenantData.first_name || ""} ${tenantData.last_name || ""}`.trim();
//         setTenantName(fullName);
//         setFirstName(tenantData.first_name || "");
//         setLastName(tenantData.last_name || "");

//         // Load existing media if available
//         // Load existing media previews if available
//         if (tenantData.media) {
//           if (tenantData.media.profile_picture?.location) {
//             setProfilePreview(
//               GetMediaURL(
//                 paths.media.download,
//                 tenantData.media.profile_picture.location,
//                 { quality: 80 }
//               )
//             );
//           }
//           if (tenantData.media.aadhar_front?.location) {
//             setAadharFrontPreview(
//               GetMediaURL(
//                 paths.media.download,
//                 tenantData.media.aadhar_front.location,
//                 { quality: 80 }
//               )
//             );
//           }
//           if (tenantData.media.aadhar_back?.location) {
//             setAadharBackPreview(
//               GetMediaURL(
//                 paths.media.download,
//                 tenantData.media.aadhar_back.location,
//                 { quality: 80 }
//               )
//             );
//           }
//           if (tenantData.media.pan?.location) {
//             setPanPreview(
//               GetMediaURL(paths.media.download, tenantData.media.pan.location, {
//                 quality: 80,
//               })
//             );
//           }
//           if (tenantData.media.rent_agreement?.location) {
//             setRentPreview(
//               GetMediaURL(
//                 paths.media.download,
//                 tenantData.media.rent_agreement.location,
//                 { quality: 80 }
//               )
//             );
//           }
//         }

//         // Clear not found state
//         setTimeout(() => setTenantFound(false), 3000);
//       } else {
//         setTenantDetails({});
//         setTenantNotFound(true);
//         // Clear not found state
//         setTimeout(() => setTenantNotFound(false), 3000);
//       }
//     } catch (error) {
//       console.error("Error fetching tenant:", error);
//       setTenantDetails({});
//       if (error.message?.includes("cannot be used")) {
//         setMobileNumber("");
//         alert(
//           "This mobile number cannot be used as a tenant's number. Please enter a different number."
//         );
//       }
//     } finally {
//       setIsTenantFetching(false);
//     }
//   };

//   const handleNameChange = (e) => {
//     const name = e.target.value;
//     setTenantName(name);

//     const nameParts = name.trim().split(/\s+/);
//     setFirstName(nameParts[0] || "");
//     setLastName(nameParts.slice(1).join(" ") || "");
//   };

//   // const handleFileChange = (e, setFile, setPreview = null) => {
//   //   const file = e.target.files[0];
//   //   setFile(file);
//   //   if (file && setPreview) {
//   //     const reader = new FileReader();
//   //     reader.onloadend = () => {
//   //       setPreview(reader.result);
//   //     };
//   //     reader.readAsDataURL(file);
//   //   }
//   // };

//   // Enhanced file change handler with preview and upload
//   const handleFileChange = (e, fileType) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     // Validate file type
//     if (!file.type.startsWith("image/")) {
//       alert("Please select an image file");
//       return;
//     }

//     // Validate file size (max 5MB)
//     if (file.size > 5 * 1024 * 1024) {
//       alert("File size should be less than 5MB");
//       return;
//     }

//     // Create preview
//     const reader = new FileReader();
//     reader.onloadend = () => {
//       const preview = reader.result;

//       // Update state based on file type
//       switch (fileType) {
//         case "profile":
//           setProfilePicture(file);
//           setProfilePreview(preview);
//           break;
//         case "aadharFront":
//           setAadharFront(file);
//           setAadharFrontPreview(preview);
//           break;
//         case "aadharBack":
//           setAadharBack(file);
//           setAadharBackPreview(preview);
//           break;
//         case "pan":
//           setPanCard(file);
//           setPanPreview(preview);
//           break;
//         case "rent":
//           setRentAgreement(file);
//           setRentPreview(preview);
//           break;
//       }
//     };
//     reader.readAsDataURL(file);
//   };

//   // Create media data object using your existing utility
//   const createMediaData = (file, basePath, fileName) => {
//     if (!file) return null;

//     return {
//       name: fileName || file.name,
//       path: file.path || file.name,
//       type: file.type,
//       height: file.height || 0,
//       width: file.width || 0,
//       size: file.size,
//       originalPath: file.originalPath || file.name,
//       description: "",
//     };
//   };

//   // Upload file to Firebase Storage
//   const uploadFileToFirebase = async (file, path) => {
//     try {
//       const fileName = `${Date.now()}_${file.name}`;
//       const fileRef = ref(storage, `${path}/${fileName}`);

//       const snapshot = await uploadBytes(fileRef, file);
//       const downloadURL = await getDownloadURL(snapshot.ref);

//       return {
//         location: downloadURL,
//         filename: fileName,
//         size: file.size,
//         type: file.type,
//       };
//     } catch (error) {
//       console.error("Error uploading file:", error);
//       throw error;
//     }
//   };

//   // Upload all files before adding tenant
//   const uploadAllFiles = async () => {
//     const uploads = {};
//     const filesToUpload = [
//       { key: "profile_picture", data: profilePicture, path: "tenants/profile" },
//       { key: "aadhar_front", data: aadharFront, path: "tenants/aadhar" },
//       { key: "aadhar_back", data: aadharBack, path: "tenants/aadhar" },
//       { key: "pan", data: panCard, path: "tenants/pan" },
//       {
//         key: "rent_agreement",
//         data: rentAgreement,
//         path: "tenants/agreements",
//       },
//     ];

//     for (const { key, data, path } of filesToUpload) {
//       if (data.file) {
//         try {
//           setUploadingFiles((prev) => ({ ...prev, [key]: true }));
//           const uploadResult = await uploadFileToFirebase(data.file, path);
//           uploads[key] = uploadResult;
//         } catch (error) {
//           console.error(`Error uploading ${key}:`, error);
//           alert(`Failed to upload ${key.replace("_", " ")}. Please try again.`);
//           throw error;
//         } finally {
//           setUploadingFiles((prev) => ({ ...prev, [key]: false }));
//         }
//       } else if (data.url) {
//         // Use existing URL for files not changed
//         uploads[key] = { location: data.url };
//       }
//     }

//     return uploads;
//   };

//   const handleAddTenant = async () => {
//     // Check for duplicate tenant
//     const duplicateTenant = existingTenantList.find(
//       (item) => item.mobile === mobileNumber
//     );
//     if (duplicateTenant) {
//       alert(
//         "This tenant is already added to the agreement. Use a different mobile number to add a new tenant."
//       );
//       return;
//     }

//     try {
//       setLoading(true);

//       // Upload files first
//       const uploadedFiles = await uploadAllFiles();

//       const newTenant = isTenantDetailsEmpty
//         ? {
//             first_name: firstName,
//             last_name: lastName,
//             mobile: mobileNumber,
//             profile_picture: profilePicture,
//             aadhar_front: aadharFront,
//             aadhar_back: aadharBack,
//             pan: panCard,
//             rent_agreement: rentAgreement,
//             // media: uploadedFiles,
//             tenant_in_db: false,
//             tenant_in_agreement: false,
//             is_media_modified: true,
//           }
//         : {
//             ...tenantDetails,
//             // media: { ...tenantDetails.media, ...uploadedFiles },
//             profile_picture: profilePicture || tenantDetails.profile_picture,
//             aadhar_front: aadharFront,
//             aadhar_back: aadharBack,
//             pan: panCard,
//             rent_agreement: rentAgreement,
//             is_media_modified: !!(
//               profilePicture ||
//               aadharFront ||
//               aadharBack ||
//               panCard ||
//               rentAgreement
//             ),
//             // is_media_modified: Object.keys(uploadedFiles).length > 0,
//           };

//       const newTenantList = [...existingTenantList, newTenant];

//       // Update navigation logic for modification flow
//       if (isModifying) {
//         navigate(
//           `/dashboard/agreements/${originalAgreement.entity_id}/modify/review-tenants`,
//           {
//             state: {
//               modifiedAgreementData,
//               originalAgreement,
//               tenantList: newTenantList,
//               isModifying: true,
//               fromAddNewTenant: true, // Flag to indicate we're coming back from add tenant
//             },
//           }
//         );
//       } else {
//         // Existing navigation logic for new agreements
//         navigate(
//           `/dashboard/my-properties/${unitId}/add-agreement/add-more-tenant`,
//           {
//             state: {
//               agreementBody,
//               unit,
//               tenantList: newTenantList,
//               isUpdate,
//               originalAgreement,
//               fromAddNewTenant: true,
//             },
//           }
//         );
//       }

//       addToCurrentAgreement(newTenant);

//       navigate(
//         `/dashboard/my-properties/${unitId}/add-agreement/add-more-tenant`,
//         {
//           state: {
//             agreementBody,
//             unit,
//             tenantList: newTenantList,
//             isUpdate,
//             originalAgreement,
//           },
//         }
//       );

//       // In AddNewTenant handleAddTenant:
//       console.log("Existing tenant list:", existingTenantList);
//       console.log("New tenant:", newTenant);
//       console.log("Updated tenant list:", newTenantList);
//     } catch (error) {
//       console.error("Error adding tenant:", error);
//       alert("Failed to add tenant. Please try again.");
//     } finally {
//       setLoading(false);
//     }

//     // Add to context as well

//     // if (isFromAddMoreTenant) {
//     //   // Go back to AddMoreTenant with updated list
//     //   navigate(-1, {
//     //     state: {
//     //       ...location.state,
//     //       tenantList: newTenantList,
//     //     },
//     //   });
//     // } else {
//     //   // Navigate to AddMoreTenant
//     //   navigate(
//     //     `/dashboard/my-properties/${unitId}/add-agreement/add-more-tenant`,
//     //     {
//     //       state: {
//     //         agreementBody,
//     //         unit,
//     //         tenantList: newTenantList,
//     //         isUpdate,
//     //         originalAgreement,
//     //       },
//     //     }
//     //   );
//     // }
//     // Navigate with updated list
//   };

//   const removeFile = (type) => {
//     switch (type) {
//       case "profile":
//         setProfilePicture(null);
//         setProfilePreview(null);
//         break;
//       case "aadharFront":
//         setAadharFront(null);
//         setAadharFrontPreview(null);
//         break;
//       case "aadharBack":
//         setAadharBack(null);
//         setAadharBackPreview(null);
//         break;
//       case "pan":
//         setPanCard(null);
//         setPanPreview(null);
//         break;
//       case "rent":
//         setRentAgreement(null);
//         setRentPreview(null);
//         break;
//     }
//   };

//   const viewImage = (imageData) => {
//     const imageUrl = imageData.preview || imageData.url;
//     if (imageUrl) {
//       setSelectedImage(imageUrl);
//       setImageModalOpen(true);
//     }
//   };

//   // Document upload component
//   const DocumentUpload = ({
//     label,
//     file,
//     preview,
//     fileType,
//     verified = false,
//   }) => {
//     const hasFile = file || preview;

//     return (
//       <div className="mb-4">
//         <label className="block text-sm font-medium text-gray-700 mb-2">
//           {label}
//         </label>

//         <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center hover:border-blue-400 transition-colors">
//           {hasFile ? (
//             <div className="space-y-2">
//               <div className="flex items-center justify-center space-x-2">
//                 <span className="text-green-600 text-sm">✓ File selected</span>
//                 <button
//                   type="button"
//                   onClick={() => viewImage(preview)}
//                   className="text-blue-600 hover:text-blue-800 text-sm"
//                 >
//                   <FaEye />
//                 </button>
//                 <button
//                   type="button"
//                   onClick={() => removeFile(fileType)}
//                   className="text-red-500 hover:text-red-700 text-sm"
//                 >
//                   <FaTimes />
//                 </button>
//               </div>
//               <div>
//                 <input
//                   type="file"
//                   accept="image/*"
//                   onChange={(e) => handleFileChange(e, fileType)}
//                   className="hidden"
//                   id={`upload-${fileType}`}
//                 />
//                 <label
//                   htmlFor={`upload-${fileType}`}
//                   className="text-blue-600 hover:text-blue-800 text-sm cursor-pointer"
//                 >
//                   Replace file
//                 </label>
//               </div>
//             </div>
//           ) : (
//             <div>
//               <input
//                 type="file"
//                 accept="image/*"
//                 onChange={(e) => handleFileChange(e, fileType)}
//                 className="hidden"
//                 id={`upload-${fileType}`}
//               />
//               <label
//                 htmlFor={`upload-${fileType}`}
//                 className="flex flex-col items-center space-y-2 cursor-pointer"
//               >
//                 <FaUpload className="text-gray-400 text-xl" />
//                 <span className="text-blue-600 hover:text-blue-800">
//                   Upload {label}
//                 </span>
//                 <span className="text-xs text-gray-500">
//                   PNG, JPG up to 5MB
//                 </span>
//               </label>
//             </div>
//           )}

//           {verified && (
//             <p className="text-xs text-green-600 mt-2">✓ Already verified</p>
//           )}
//         </div>
//       </div>
//     );
//   };

//   const [loading, setLoading] = useState(false);

//   // Document upload handlers
//   const openDocumentModal = (documentType, documentSide = null) => {
//     setCurrentDocumentType(documentType);
//     setCurrentDocumentSide(documentSide);
//     setDocumentModalOpen(true);
//   };

//   const handleDocumentUpload = (e) => {
//     const file = e.target.files[0];
//     if (currentDocumentType === "aadhar" && currentDocumentSide === "front") {
//       setAadharFront(file);
//     } else if (
//       currentDocumentType === "aadhar" &&
//       currentDocumentSide === "back"
//     ) {
//       setAadharBack(file);
//     } else if (currentDocumentType === "pan") {
//       setPanCard(file);
//     } else if (currentDocumentType === "rent") {
//       setRentAgreement(file);
//     }
//     setDocumentModalOpen(false);
//   };

//   // const removeFile = (type) => {
//   //   switch (type) {
//   //     case "profile":
//   //       setProfilePicture(null);
//   //       setProfilePicturePreview(null);
//   //       break;
//   //     case "aadharFront":
//   //       setAadharFront(null);
//   //       break;
//   //     case "aadharBack":
//   //       setAadharBack(null);
//   //       break;
//   //     case "pan":
//   //       setPanCard(null);
//   //       break;
//   //     case "rent":
//   //       setRentAgreement(null);
//   //       break;
//   //   }
//   // };

//   return (
//     <div className="min-h-screen w-full p-6">
//       <div className="container mx-auto max-w-4xl">
//         {/* Header */}
//         <div className="mb-6">
//           <h2 className="text-2xl font-semibold mb-2">Add Tenant</h2>
//           {unit && (
//             <div className="text-gray-600">
//               <p className="font-medium">{unit.unit_name}</p>
//               <p>
//                 {unit.building_name}, {unit.address}
//               </p>
//             </div>
//           )}
//         </div>

//         {/* Tenant Details Section */}
//         <div className="bg-white rounded-lg shadow-sm border p-6 mb-6">
//           <h3 className="text-lg font-medium mb-4">Tenant Details</h3>

//           {/* Profile Picture */}
//           {/* <div className="flex justify-center mb-6">
//             <div className="relative w-24 h-24 rounded-full border-2 border-gray-300 flex items-center justify-center overflow-hidden bg-gray-50">
//               {profilePicturePreview ||
//               (tenantDetails.profile_picture && !profilePicture) ? (
//                 <img
//                   src={profilePicturePreview || tenantDetails.profile_picture}
//                   alt="Profile"
//                   className="w-full h-full object-cover"
//                 />
//               ) : (
//                 <FaCamera className="text-gray-400 text-xl" />
//               )}
//               <input
//                 type="file"
//                 accept="image/*"
//                 onChange={(e) =>
//                   handleFileChange(
//                     e,
//                     setProfilePicture,
//                     setProfilePicturePreview
//                   )
//                 }
//                 className="absolute inset-0 opacity-0 cursor-pointer"
//               />
//             </div>
//           </div> */}
//           {/* Profile Picture */}
//           <div className="flex justify-center mb-6">
//             <div className="relative w-24 h-24 rounded-full border-2 border-gray-300 flex items-center justify-center overflow-hidden bg-gray-50">
//               {profilePreview ? (
//                 <img
//                   src={profilePreview}
//                   alt="Profile"
//                   className="w-full h-full object-cover cursor-pointer"
//                   onClick={() => viewImage(profilePreview)}
//                 />
//               ) : (
//                 <FaCamera className="text-gray-400 text-xl" />
//               )}
//               <input
//                 type="file"
//                 accept="image/*"
//                 onChange={(e) => handleFileChange(e, "profile")}
//                 className="absolute inset-0 opacity-0 cursor-pointer"
//               />
//             </div>
//           </div>

//           {/* Mobile Number */}
//           <div className="mb-4">
//             <label
//               htmlFor="mobileNumber"
//               className="block text-sm font-medium text-gray-700 mb-2"
//             >
//               Mobile Number <span className="text-red-500">*</span>
//             </label>
//             <div className="relative">
//               <input
//                 id="mobileNumber"
//                 type="tel"
//                 value={mobileNumber}
//                 onChange={(e) => setMobileNumber(e.target.value)}
//                 maxLength={10}
//                 className="w-full px-4 py-3 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                 placeholder="Enter 10-digit mobile number"
//                 disabled={isTenantFetching}
//               />
//               <FaPhone className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
//               {isTenantFetching && (
//                 <div className="absolute right-10 top-1/2 transform -translate-y-1/2">
//                   <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500"></div>
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* Tenant Name */}
//           <div className="mb-4">
//             <label
//               htmlFor="tenantName"
//               className="block text-sm font-medium text-gray-700 mb-2"
//             >
//               Tenant Name <span className="text-red-500">*</span>
//             </label>
//             <input
//               id="tenantName"
//               type="text"
//               value={tenantName}
//               onChange={handleNameChange}
//               className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//               placeholder="Enter full name"
//               minLength="3"
//               readOnly={!isTenantDetailsEmpty}
//               disabled={isTenantFetching}
//             />
//             {!isTenantDetailsEmpty && (
//               <p className="text-xs text-gray-500 mt-1">
//                 Tenant details loaded from database
//               </p>
//             )}
//           </div>

//           {/* Status Messages */}
//           {tenantFound && (
//             <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded-lg">
//               <p className="text-sm text-green-800 font-medium">
//                 ✅ Tenant found. Please verify the details.
//               </p>
//             </div>
//           )}

//           {tenantNotFound && (
//             <div className="mb-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
//               <p className="text-sm text-yellow-800 font-medium">
//                 ⚠️ Tenant not found. Please enter the details manually.
//               </p>
//             </div>
//           )}
//         </div>

//         {/* Documents Section */}

//         {/* <div className="bg-white rounded-lg shadow-sm border p-6 mb-6">
//           <h3 className="text-lg font-medium mb-4">Add Documents</h3>

//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-2">
//               Upload Aadhar Card
//             </label>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center hover:border-blue-400 transition-colors">
//                 <button
//                   type="button"
//                   onClick={() => openDocumentModal("aadhar", "front")}
//                   className="w-full text-blue-600 hover:text-blue-800"
//                 >
//                   {aadharFront
//                     ? "✓ Front Side Uploaded"
//                     : "+ Add Front Aadhar Photo"}
//                 </button>
//                 {aadharFront && (
//                   <button
//                     type="button"
//                     onClick={() => removeFile("aadharFront")}
//                     className="mt-2 text-red-500 text-xs"
//                   >
//                     Remove
//                   </button>
//                 )}
//               </div>

//               <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center hover:border-blue-400 transition-colors">
//                 <button
//                   type="button"
//                   onClick={() => openDocumentModal("aadhar", "back")}
//                   className="w-full text-blue-600 hover:text-blue-800"
//                 >
//                   {aadharBack
//                     ? "✓ Back Side Uploaded"
//                     : "+ Add Back Aadhar Photo"}
//                 </button>
//                 {aadharBack && (
//                   <button
//                     type="button"
//                     onClick={() => removeFile("aadharBack")}
//                     className="mt-2 text-red-500 text-xs"
//                   >
//                     Remove
//                   </button>
//                 )}
//               </div>
//             </div>
//             {tenantDetails.aadhar_verified && (
//               <p className="text-xs text-green-600 mt-1">
//                 ✓ Aadhar already verified
//               </p>
//             )}
//           </div>

//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-2">
//               Upload PAN Card
//             </label>
//             <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center hover:border-blue-400 transition-colors">
//               <button
//                 type="button"
//                 onClick={() => openDocumentModal("pan")}
//                 className="w-full text-blue-600 hover:text-blue-800"
//               >
//                 {panCard ? "✓ PAN Card Uploaded" : "+ Add PAN Card Photo"}
//               </button>
//               {panCard && (
//                 <button
//                   type="button"
//                   onClick={() => removeFile("pan")}
//                   className="mt-2 text-red-500 text-xs"
//                 >
//                   Remove
//                 </button>
//               )}
//             </div>
//             {tenantDetails.pan_verified && (
//               <p className="text-xs text-green-600 mt-1">
//                 ✓ PAN already verified
//               </p>
//             )}
//           </div>

//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-2">
//               Upload Rent Agreement
//             </label>
//             <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center hover:border-blue-400 transition-colors">
//               <button
//                 type="button"
//                 onClick={() => openDocumentModal("rent")}
//                 className="w-full text-blue-600 hover:text-blue-800"
//               >
//                 {rentAgreement
//                   ? "✓ Rent Agreement Uploaded"
//                   : "+ Add Rent Agreement Photo"}
//               </button>
//               {rentAgreement && (
//                 <button
//                   type="button"
//                   onClick={() => removeFile("rent")}
//                   className="mt-2 text-red-500 text-xs"
//                 >
//                   Remove
//                 </button>
//               )}
//             </div>
//           </div>
//         </div> */}

//         {/* Documents Section */}
//         <div className="bg-white rounded-lg shadow-sm border p-6 mb-6">
//           <h3 className="text-lg font-medium mb-4">Add Documents</h3>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//             {/* Aadhar Card Front */}

//             <DocumentUpload
//               label="Aadhar Card (Front)"
//               file={aadharFront}
//               preview={aadharFrontPreview}
//               fileType="aadharFront"
//               verified={tenantDetails.aadhar_verified}
//             />

//             {/* Aadhar Card Back */}
//             <DocumentUpload
//               label="Aadhar Card (Back)"
//               file={aadharBack}
//               preview={aadharBackPreview}
//               fileType="aadharBack"
//               verified={tenantDetails.aadhar_verified}
//             />

//             {/* PAN Card */}
//             <DocumentUpload
//               label="PAN Card"
//               file={panCard}
//               preview={panPreview}
//               fileType="pan"
//               verified={tenantDetails.pan_verified}
//             />

//             {/* Rent Agreement */}
//             <DocumentUpload
//               label="Rent Agreement"
//               file={rentAgreement}
//               preview={rentPreview}
//               fileType="rent"
//             />
//           </div>
//         </div>

//         {/* Submit Button */}
//         {/* <div className="flex justify-end">
//           <CustomButton
//             tailwindClasses={`px-8 py-3 text-lg font-medium ${
//               !isContinueActive
//                 ? "bg-gray-400 text-gray-700 cursor-not-allowed"
//                 : "bg-blue-500 text-white hover:bg-blue-600"
//             }`}
//             label="Add Tenant"
//             onClick={handleAddTenant}
//             disabled={!isContinueActive || isTenantFetching}
//           />
//         </div> */}
//         <div className="flex justify-end">
//           <CustomButton
//             tailwindClasses={`px-8 py-3 text-lg font-medium ${
//               !isContinueActive || loading
//                 ? "bg-gray-400 text-gray-700 cursor-not-allowed"
//                 : "bg-blue-500 text-white hover:bg-blue-600"
//             }`}
//             label={loading ? "Adding Tenant..." : "Add Tenant"}
//             onClick={handleAddTenant}
//             disabled={!isContinueActive || isTenantFetching || loading}
//           />
//         </div>

//         {/* Image Modal */}
//         {isImageModalOpen && selectedImage && (
//           <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50">
//             <div className="relative max-w-4xl max-h-screen p-4">
//               <button
//                 onClick={() => setImageModalOpen(false)}
//                 className="absolute top-2 right-2 text-white hover:text-gray-300 text-2xl z-10"
//               >
//                 <FaTimes />
//               </button>
//               <img
//                 src={selectedImage}
//                 alt="Document preview"
//                 className="max-w-full max-h-full object-contain"
//               />
//             </div>
//           </div>
//         )}

//         {/* Document Upload Modal */}
//         {isDocumentModalOpen && (
//           <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
//             <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md mx-4">
//               <h3 className="text-lg font-semibold mb-4">
//                 Upload{" "}
//                 {currentDocumentType === "aadhar"
//                   ? "Aadhar Card"
//                   : currentDocumentType === "pan"
//                     ? "PAN Card"
//                     : "Rent Agreement"}
//                 {currentDocumentSide && ` (${currentDocumentSide})`}
//               </h3>
//               <input
//                 type="file"
//                 accept="image/*"
//                 onChange={handleDocumentUpload}
//                 className="w-full p-2 border border-gray-300 rounded-md"
//               />
//               <div className="flex gap-3 mt-4">
//                 <button
//                   onClick={() => setDocumentModalOpen(false)}
//                   className="flex-1 bg-gray-500 text-white py-2 rounded hover:bg-gray-600"
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AddNewTenant;

import React, { useState, useContext, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import CustomButton from "../Buttons/CustomButton";
import APICall from "../../Utility/APICall";
import { paths } from "../../Utility/Constants";
import { useAuth } from "../../Utility/AuthProvider";
import { useTenantContext } from "./TenantContext";
import {
  ref,
  uploadBytesResumable,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import { storage } from "../../Utility/firebase";
import { GetUploadMediaBaseLocation, GetMediaURL } from "../../Utility/APICall";
import {
  FaPlus,
  FaEye,
  FaEdit,
  FaTrash,
  FaUpload,
  FaCamera,
  FaTimes,
  FaPhone,
} from "react-icons/fa";

const AddNewTenant = () => {
  const { jwt, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { unitId } = useParams();
  const { addToCurrentAgreement } = useTenantContext();

  // Get agreement data from navigation state
  const agreementBody = location.state?.agreementBody || null;
  const unit = location.state?.unit || null;
  const isFromAddMoreTenant = location.state?.fromAddMoreTenant || false;
  const existingTenantList = location.state?.tenantList || [];
  const isUpdate = location.state?.isUpdate || false;
  const originalAgreement = location.state?.originalAgreement || null;

  // For modification flow
  const modifiedAgreementData = location.state?.modifiedAgreementData || null;
  const isModifying = location.state?.isModifying || false;
  const fromReviewTenants = location.state?.fromReviewTenants || false;

  // For editing existing tenant
  const editingTenant = location.state?.editingTenant || null;
  const editingIndex = location.state?.editingIndex || null;

  // State for form fields
  const [mobileNumber, setMobileNumber] = useState(editingTenant?.mobile || "");
  const [tenantName, setTenantName] = useState(
    editingTenant
      ? `${editingTenant.first_name || ""} ${editingTenant.last_name || ""}`.trim()
      : ""
  );
  const [firstName, setFirstName] = useState(editingTenant?.first_name || "");
  const [lastName, setLastName] = useState(editingTenant?.last_name || "");

  // State for file uploads - storing file objects for upload
  const [filesToUpload, setFilesToUpload] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});
  const [uploadingFiles, setUploadingFiles] = useState({});

  // State for file previews and existing media
  const [profilePreview, setProfilePreview] = useState(null);
  const [aadharFrontPreview, setAadharFrontPreview] = useState(null);
  const [aadharBackPreview, setAadharBackPreview] = useState(null);
  const [panPreview, setPanPreview] = useState(null);
  const [rentPreview, setRentPreview] = useState(null);

  // State for existing media (for editing)
  const [existingMedia, setExistingMedia] = useState({});
  const [mediaToDelete, setMediaToDelete] = useState([]);

  // State for tenant fetching
  const [isTenantFetching, setIsTenantFetching] = useState(false);
  const [tenantDetails, setTenantDetails] = useState({});
  const [tenantFound, setTenantFound] = useState(false);
  const [tenantNotFound, setTenantNotFound] = useState(false);

  // State for modals
  const [selectedImage, setSelectedImage] = useState(null);
  const [isImageModalOpen, setImageModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Form validation
  const [isContinueActive, setIsContinueActive] = useState(false);
  const isTenantDetailsEmpty = Object.keys(tenantDetails).length === 0;

  // Initialize editing data
  useEffect(() => {
    if (editingTenant) {
      // Load existing media if editing
      if (editingTenant.media) {
        setExistingMedia(editingTenant.media);

        // Set previews for existing media
        if (editingTenant.media.profile_picture?.location) {
          setProfilePreview(
            GetMediaURL(
              paths.media.download,
              editingTenant.media.profile_picture.location,
              { quality: 80 }
            )
          );
        }
        if (editingTenant.media.aadhar_front?.location) {
          setAadharFrontPreview(
            GetMediaURL(
              paths.media.download,
              editingTenant.media.aadhar_front.location,
              { quality: 80 }
            )
          );
        }
        if (editingTenant.media.aadhar_back?.location) {
          setAadharBackPreview(
            GetMediaURL(
              paths.media.download,
              editingTenant.media.aadhar_back.location,
              { quality: 80 }
            )
          );
        }
        if (editingTenant.media.pan?.location) {
          setPanPreview(
            GetMediaURL(
              paths.media.download,
              editingTenant.media.pan.location,
              { quality: 80 }
            )
          );
        }
        if (editingTenant.media.rent_agreement?.location) {
          setRentPreview(
            GetMediaURL(
              paths.media.download,
              editingTenant.media.rent_agreement.location,
              { quality: 80 }
            )
          );
        }
      }

      // If editing existing tenant from DB, set tenant details
      if (editingTenant.tenant_in_db) {
        setTenantDetails(editingTenant);
      }
    }
  }, [editingTenant]);

  // Check if mobile number is 10 digits and fetch tenant
  useEffect(() => {
    if (mobileNumber.length === 10 && !editingTenant) {
      fetchTenantDetails();
    } else if (mobileNumber.length !== 10) {
      if (!editingTenant) {
        setTenantDetails({});
        setTenantFound(false);
        setTenantNotFound(false);
      }
    }
  }, [mobileNumber, editingTenant]);

  // Validate form
  useEffect(() => {
    const isValid =
      mobileNumber.length === 10 &&
      (!isTenantDetailsEmpty || tenantName.length > 2);
    setIsContinueActive(isValid);
  }, [mobileNumber, tenantDetails, tenantName, isTenantDetailsEmpty]);

  const fetchTenantDetails = async () => {
    try {
      setIsTenantFetching(true);
      setTenantFound(false);
      setTenantNotFound(false);

      const response = await APICall(
        "POST",
        paths.tenant.validate,
        { mobile: mobileNumber },
        undefined,
        jwt
      );

      if (response.status === "success" && response.response.is_tenant) {
        const tenantData = {
          ...response.response,
          tenant_in_db: true,
        };
        setTenantDetails(tenantData);
        setTenantFound(true);

        // Auto-fill name if tenant found
        const fullName =
          `${tenantData.first_name || ""} ${tenantData.last_name || ""}`.trim();
        setTenantName(fullName);
        setFirstName(tenantData.first_name || "");
        setLastName(tenantData.last_name || "");

        // Load existing media previews if available
        if (tenantData.media) {
          setExistingMedia(tenantData.media);

          if (tenantData.media.profile_picture?.location) {
            setProfilePreview(
              GetMediaURL(
                paths.media.download,
                tenantData.media.profile_picture.location,
                { quality: 80 }
              )
            );
          }
          if (tenantData.media.aadhar_front?.location) {
            setAadharFrontPreview(
              GetMediaURL(
                paths.media.download,
                tenantData.media.aadhar_front.location,
                { quality: 80 }
              )
            );
          }
          if (tenantData.media.aadhar_back?.location) {
            setAadharBackPreview(
              GetMediaURL(
                paths.media.download,
                tenantData.media.aadhar_back.location,
                { quality: 80 }
              )
            );
          }
          if (tenantData.media.pan?.location) {
            setPanPreview(
              GetMediaURL(paths.media.download, tenantData.media.pan.location, {
                quality: 80,
              })
            );
          }
          if (tenantData.media.rent_agreement?.location) {
            setRentPreview(
              GetMediaURL(
                paths.media.download,
                tenantData.media.rent_agreement.location,
                { quality: 80 }
              )
            );
          }
        }

        setTimeout(() => setTenantFound(false), 3000);
      } else {
        setTenantDetails({});
        setTenantNotFound(true);
        setTimeout(() => setTenantNotFound(false), 3000);
      }
    } catch (error) {
      console.error("Error fetching tenant:", error);
      setTenantDetails({});
      if (error.message?.includes("cannot be used")) {
        setMobileNumber("");
        alert(
          "This mobile number cannot be used as a tenant's number. Please enter a different number."
        );
      }
    } finally {
      setIsTenantFetching(false);
    }
  };

  const handleNameChange = (e) => {
    const name = e.target.value;
    setTenantName(name);

    const nameParts = name.trim().split(/\s+/);
    setFirstName(nameParts[0] || "");
    setLastName(nameParts.slice(1).join(" ") || "");
  };

  // Enhanced file change handler with preview and upload preparation
  const handleFileChange = (e, fileType) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.type.startsWith("image/")) {
      alert("Please select an image file");
      return;
    }

    // Validate file size (max 5MB, 2MB for profile)
    const maxSize = fileType === "profile" ? 2 * 1024 * 1024 : 5 * 1024 * 1024;
    if (file.size > maxSize) {
      const maxSizeMB = fileType === "profile" ? "2MB" : "5MB";
      alert(`File size should be less than ${maxSizeMB}`);
      return;
    }

    // Create preview
    const reader = new FileReader();
    reader.onloadend = () => {
      const preview = reader.result;

      // Update preview based on file type
      switch (fileType) {
        case "profile":
          setProfilePreview(preview);
          break;
        case "aadharFront":
          setAadharFrontPreview(preview);
          break;
        case "aadharBack":
          setAadharBackPreview(preview);
          break;
        case "pan":
          setPanPreview(preview);
          break;
        case "rent":
          setRentPreview(preview);
          break;
      }

      // Add to files to upload
      const fileToUpload = {
        actualFile: file,
        name: file.name,
        type: fileType,
        previewUrl: preview,
      };

      setFilesToUpload((prev) => {
        const filtered = prev.filter((f) => f.type !== fileType);
        return [...filtered, fileToUpload];
      });

      // If editing and replacing existing media, mark for deletion
      if (existingMedia[fileType]?.location) {
        setMediaToDelete((prev) => {
          if (!prev.includes(existingMedia[fileType].location)) {
            return [...prev, existingMedia[fileType].location];
          }
          return prev;
        });
      }
    };
    reader.readAsDataURL(file);
  };

  const removeFile = (type) => {
    // Clear preview
    switch (type) {
      case "profile":
        setProfilePreview(null);
        break;
      case "aadharFront":
        setAadharFrontPreview(null);
        break;
      case "aadharBack":
        setAadharBackPreview(null);
        break;
      case "pan":
        setPanPreview(null);
        break;
      case "rent":
        setRentPreview(null);
        break;
    }

    // Remove from files to upload
    setFilesToUpload((prev) => prev.filter((f) => f.type !== type));

    // If removing existing media, mark for deletion
    if (existingMedia[type]?.location) {
      setMediaToDelete((prev) => {
        if (!prev.includes(existingMedia[type].location)) {
          return [...prev, existingMedia[type].location];
        }
        return prev;
      });
    }
  };

  const viewImage = (imageUrl) => {
    setSelectedImage(imageUrl);
    setImageModalOpen(true);
  };

  // Upload files to Firebase (similar to AddNewUnit)
  const uploadFilesToFirebase = async (tenantId) => {
    const newlyUploadedMediaObjects = {};

    if (filesToUpload.length === 0) {
      return newlyUploadedMediaObjects;
    }

    try {
      for (let i = 0; i < filesToUpload.length; i++) {
        const fileToUpload = filesToUpload[i];
        const actualFile = fileToUpload.actualFile;

        setUploadProgress((prev) => ({ ...prev, [i]: 0 }));

        // Get upload path based on file type
        let baseUploadLocation;
        switch (fileToUpload.type) {
          case "profile":
            baseUploadLocation = GetUploadMediaBaseLocation(
              "tenants/profile",
              user
            );
            break;
          case "aadharFront":
          case "aadharBack":
            baseUploadLocation = GetUploadMediaBaseLocation(
              "tenants/aadhar",
              user
            );
            break;
          case "pan":
            baseUploadLocation = GetUploadMediaBaseLocation(
              "tenants/pan",
              user
            );
            break;
          case "rent":
            baseUploadLocation = GetUploadMediaBaseLocation(
              "tenants/agreement",
              user
            );
            break;
          default:
            baseUploadLocation = GetUploadMediaBaseLocation(
              "tenants/documents",
              user
            );
        }

        const uniqueFileNameInStorage = `${Date.now()}_${actualFile.name}`;
        const firebasePath = `${baseUploadLocation}/${tenantId}/${uniqueFileNameInStorage}`;
        const storageRef = ref(storage, firebasePath);
        const uploadTask = uploadBytesResumable(storageRef, actualFile);

        await new Promise((resolve, reject) => {
          uploadTask.on(
            "state_changed",
            (snapshot) => {
              const progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              setUploadProgress((prev) => ({ ...prev, [i]: progress }));
            },
            (uploadError) => {
              console.error(
                `Upload failed for ${actualFile.name}:`,
                uploadError
              );
              setError(
                (prev) => prev + `Upload error for ${actualFile.name}. `
              );
              resolve(); // Continue with other uploads
            },
            async () => {
              try {
                const downloadURL = await getDownloadURL(
                  uploadTask.snapshot.ref
                );

                // Map file type to media key
                let mediaKey;
                switch (fileToUpload.type) {
                  case "profile":
                    mediaKey = "profile_picture";
                    break;
                  case "aadharFront":
                    mediaKey = "aadhar_front";
                    break;
                  case "aadharBack":
                    mediaKey = "aadhar_back";
                    break;
                  case "pan":
                    mediaKey = "pan";
                    break;
                  case "rent":
                    mediaKey = "rent_agreement";
                    break;
                }

                newlyUploadedMediaObjects[mediaKey] = {
                  name: actualFile.name,
                  location: firebasePath,
                  url: downloadURL,
                  type: actualFile.type,
                  size: actualFile.size,
                  description: "",
                };
                resolve();
              } catch (getUrlError) {
                console.error(
                  `Get URL failed for ${actualFile.name}:`,
                  getUrlError
                );
                setError(
                  (prev) => prev + `URL fetch error for ${actualFile.name}. `
                );
                resolve();
              }
            }
          );
        });
      }
    } catch (error) {
      console.error("Error uploading files:", error);
      throw error;
    }

    return newlyUploadedMediaObjects;
  };

  // Delete old files from Firebase
  const deleteOldFilesFromFirebase = async () => {
    if (mediaToDelete.length === 0) return;

    try {
      const deletePromises = mediaToDelete.map((locationPath) => {
        const fileRef = ref(storage, locationPath);
        return deleteObject(fileRef).catch((err) => {
          console.warn(
            `Failed to delete ${locationPath} from Firebase:`,
            err.message
          );
        });
      });
      await Promise.all(deletePromises);
      setMediaToDelete([]);
    } catch (error) {
      console.error("Error deleting old files:", error);
    }
  };

  const handleAddTenant = async () => {
    // Check for duplicate tenant (excluding editing tenant)
    const duplicateTenant = existingTenantList.find(
      (item, index) => item.mobile === mobileNumber && index !== editingIndex
    );
    if (duplicateTenant) {
      alert(
        "This tenant is already added to the agreement. Use a different mobile number to add a new tenant."
      );
      return;
    }

    try {
      setLoading(true);
      setError("");

      // Generate temporary tenant ID for file upload paths
      const tempTenantId = editingTenant?.entity_id || `temp_${Date.now()}`;

      // Step 1: Delete old files if editing
      await deleteOldFilesFromFirebase();

      // Step 2: Upload new files
      const uploadedFiles = await uploadFilesToFirebase(tempTenantId);

      // Step 3: Combine existing media with newly uploaded media
      const finalMediaList = { ...existingMedia };

      // Update with newly uploaded files
      Object.keys(uploadedFiles).forEach((key) => {
        finalMediaList[key] = uploadedFiles[key];
      });

      // Remove deleted media from final list
      mediaToDelete.forEach((deletedPath) => {
        Object.keys(finalMediaList).forEach((key) => {
          if (finalMediaList[key]?.location === deletedPath) {
            delete finalMediaList[key];
          }
        });
      });

      const newTenant = isTenantDetailsEmpty
        ? {
            first_name: firstName,
            last_name: lastName,
            mobile: mobileNumber,
            media: finalMediaList,
            tenant_in_db: false,
            tenant_in_agreement: false,
            is_media_modified: filesToUpload.length > 0,
            entity_id: editingTenant?.entity_id || null,
          }
        : {
            ...tenantDetails,
            media: finalMediaList,
            is_media_modified:
              filesToUpload.length > 0 || mediaToDelete.length > 0,
          };

      let newTenantList = [...existingTenantList];

      if (editingIndex !== null) {
        // Update existing tenant
        newTenantList[editingIndex] = newTenant;
      } else {
        // Add new tenant
        newTenantList.push(newTenant);
      }

      // Navigation logic for modification flow
      if (isModifying) {
        navigate(
          `/dashboard/agreements/${originalAgreement.entity_id}/modify/review-tenants`,
          {
            state: {
              modifiedAgreementData,
              originalAgreement,
              tenantList: newTenantList,
              isModifying: true,
              fromAddNewTenant: true,
            },
          }
        );
      } else {
        // Existing navigation logic for new agreements
        navigate(
          `/dashboard/my-properties/${unitId}/add-agreement/add-more-tenant`,
          {
            state: {
              agreementBody,
              unit,
              tenantList: newTenantList,
              isUpdate,
              originalAgreement,
              fromAddNewTenant: true,
            },
          }
        );
      }

      // Add to context if new tenant
      if (editingIndex === null) {
        addToCurrentAgreement(newTenant);
      }
    } catch (error) {
      console.error("Error adding tenant:", error);
      alert("Failed to add tenant. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Document upload component
  const DocumentUpload = ({ label, preview, fileType, verified = false }) => {
    const hasFile = preview;
    const isUploading = uploadingFiles[fileType];

    return (
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {label}
        </label>

        <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center hover:border-blue-400 transition-colors">
          {hasFile ? (
            <div className="space-y-2">
              <div className="flex items-center justify-center space-x-2">
                <span className="text-green-600 text-sm">✓ File selected</span>
                <button
                  type="button"
                  onClick={() => viewImage(preview)}
                  className="text-blue-600 hover:text-blue-800 text-sm"
                >
                  <FaEye />
                </button>
                <button
                  type="button"
                  onClick={() => removeFile(fileType)}
                  className="text-red-500 hover:text-red-700 text-sm"
                >
                  <FaTimes />
                </button>
              </div>
              <div>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleFileChange(e, fileType)}
                  className="hidden"
                  id={`upload-${fileType}`}
                />
                <label
                  htmlFor={`upload-${fileType}`}
                  className="text-blue-600 hover:text-blue-800 text-sm cursor-pointer"
                >
                  Replace file
                </label>
              </div>
            </div>
          ) : (
            <div>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleFileChange(e, fileType)}
                className="hidden"
                id={`upload-${fileType}`}
                disabled={isUploading}
              />
              <label
                htmlFor={`upload-${fileType}`}
                className="flex flex-col items-center space-y-2 cursor-pointer"
              >
                <FaUpload className="text-gray-400 text-xl" />
                <span className="text-blue-600 hover:text-blue-800">
                  Upload {label}
                </span>
                <span className="text-xs text-gray-500">
                  PNG, JPG up to 5MB
                </span>
              </label>
            </div>
          )}

          {isUploading && (
            <div className="mt-2">
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div
                  className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                  style={{ width: `${uploadProgress[fileType] || 0}%` }}
                ></div>
              </div>
              <p className="text-xs text-gray-600 mt-1">Uploading...</p>
            </div>
          )}

          {verified && (
            <p className="text-xs text-green-600 mt-2">✓ Already verified</p>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen w-full p-6">
      <div className="container mx-auto max-w-4xl">
        {/* Header */}
        <div className="mb-6">
          <h2 className="text-2xl font-semibold mb-2">
            {editingTenant ? "Edit Tenant" : "Add Tenant"}
          </h2>
          {unit && (
            <div className="text-gray-600">
              <p className="font-medium">{unit.unit_name}</p>
              <p>
                {unit.building_name}, {unit.address}
              </p>
            </div>
          )}
        </div>

        {/* Error Message */}
        {error && (
          <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-red-800">{error}</p>
          </div>
        )}

        {/* Tenant Details Section */}
        <div className="bg-white rounded-lg shadow-sm border p-6 mb-6">
          <h3 className="text-lg font-medium mb-4">Tenant Details</h3>

          {/* Profile Picture */}
          <div className="flex justify-center mb-6">
            <div className="relative w-24 h-24 rounded-full border-2 border-gray-300 flex items-center justify-center overflow-hidden bg-gray-50">
              {profilePreview ? (
                <img
                  src={profilePreview}
                  alt="Profile"
                  className="w-full h-full object-cover cursor-pointer"
                  onClick={() => viewImage(profilePreview)}
                />
              ) : (
                <FaCamera className="text-gray-400 text-xl" />
              )}
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleFileChange(e, "profile")}
                className="absolute inset-0 opacity-0 cursor-pointer"
                disabled={loading}
              />
            </div>
          </div>

          {/* Mobile Number */}
          <div className="mb-4">
            <label
              htmlFor="mobileNumber"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Mobile Number <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <input
                id="mobileNumber"
                type="tel"
                value={mobileNumber}
                onChange={(e) => setMobileNumber(e.target.value)}
                maxLength={10}
                className="w-full px-4 py-3 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter 10-digit mobile number"
                disabled={
                  isTenantFetching ||
                  loading ||
                  editingTenant?.tenant_in_agreement
                }
              />
              <FaPhone className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              {isTenantFetching && (
                <div className="absolute right-10 top-1/2 transform -translate-y-1/2">
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500"></div>
                </div>
              )}
            </div>
            {editingTenant?.tenant_in_agreement && (
              <p className="text-xs text-gray-500 mt-1">
                Cannot modify mobile number for existing tenant in agreement
              </p>
            )}
          </div>

          {/* Tenant Name */}
          <div className="mb-4">
            <label
              htmlFor="tenantName"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Tenant Name <span className="text-red-500">*</span>
            </label>
            <input
              id="tenantName"
              type="text"
              value={tenantName}
              onChange={handleNameChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Enter full name"
              minLength="3"
              readOnly={!isTenantDetailsEmpty && !editingTenant}
              disabled={isTenantFetching || loading}
            />
            {!isTenantDetailsEmpty && !editingTenant && (
              <p className="text-xs text-gray-500 mt-1">
                Tenant details loaded from database
              </p>
            )}
          </div>

          {/* Status Messages */}
          {tenantFound && (
            <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded-lg">
              <p className="text-sm text-green-800 font-medium">
                ✅ Tenant found. Please verify the details.
              </p>
            </div>
          )}

          {tenantNotFound && (
            <div className="mb-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
              <p className="text-sm text-yellow-800 font-medium">
                ⚠️ Tenant not found. Please enter the details manually.
              </p>
            </div>
          )}
        </div>

        {/* Documents Section */}
        <div className="bg-white rounded-lg shadow-sm border p-6 mb-6">
          <h3 className="text-lg font-medium mb-4">Add Documents</h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Aadhar Card Front */}
            <DocumentUpload
              label="Aadhar Card (Front)"
              preview={aadharFrontPreview}
              fileType="aadharFront"
              verified={tenantDetails.aadhar_verified}
            />

            {/* Aadhar Card Back */}
            <DocumentUpload
              label="Aadhar Card (Back)"
              preview={aadharBackPreview}
              fileType="aadharBack"
              verified={tenantDetails.aadhar_verified}
            />

            {/* PAN Card */}
            <DocumentUpload
              label="PAN Card"
              preview={panPreview}
              fileType="pan"
              verified={tenantDetails.pan_verified}
            />

            {/* Rent Agreement */}
            <DocumentUpload
              label="Rent Agreement"
              preview={rentPreview}
              fileType="rent"
            />
          </div>
        </div>

        {/* Submit Button */}
        <div className="flex justify-end space-x-4">
          <button
            onClick={() => navigate(-1)}
            className="px-6 py-3 bg-gray-500 text-white rounded-lg hover:bg-gray-600"
            disabled={loading}
          >
            Cancel
          </button>
          <CustomButton
            tailwindClasses={`px-8 py-3 text-lg font-medium ${
              !isContinueActive || loading
                ? "bg-gray-400 text-gray-700 cursor-not-allowed"
                : "bg-blue-500 text-white hover:bg-blue-600"
            }`}
            label={
              loading
                ? editingTenant
                  ? "Updating Tenant..."
                  : "Adding Tenant..."
                : editingTenant
                  ? "Update Tenant"
                  : "Add Tenant"
            }
            onClick={handleAddTenant}
            disabled={!isContinueActive || isTenantFetching || loading}
          />
        </div>

        {/* Image Modal */}
        {isImageModalOpen && selectedImage && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50">
            <div className="relative max-w-4xl max-h-screen p-4">
              <button
                onClick={() => setImageModalOpen(false)}
                className="absolute top-2 right-2 text-white hover:text-gray-300 text-2xl z-10"
              >
                <FaTimes />
              </button>
              <img
                src={selectedImage}
                alt="Document preview"
                className="max-w-full max-h-full object-contain"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddNewTenant;
